class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this._overlayClickHandler = this.close.bind(this);
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this._overlayClickHandler);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  lockMobileLayout() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    this.style.setProperty('position', 'fixed', 'important');
    this.style.setProperty('inset', '0', 'important');
    this.style.setProperty('width', '100vw', 'important');
    this.style.setProperty('min-width', '100vw', 'important');
    this.style.setProperty('max-width', '100vw', 'important');
    this.style.setProperty('height', '100dvh', 'important');
    this.style.setProperty('margin', '0', 'important');
    this.style.setProperty('padding', '0', 'important');

    const inner = this.querySelector('.drawer__inner') || this.querySelector('.drawer__inner-empty');
    if (!inner) return;

    inner.style.setProperty('position', 'absolute', 'important');
    inner.style.setProperty('inset', '0', 'important');
    inner.style.setProperty('width', '100vw', 'important');
    inner.style.setProperty('min-width', '100vw', 'important');
    inner.style.setProperty('max-width', '100vw', 'important');
    inner.style.setProperty('height', '100dvh', 'important');
    inner.style.setProperty('margin', '0', 'important');
    inner.style.setProperty('box-sizing', 'border-box', 'important');
    inner.style.setProperty('transform', 'none', 'important');
    inner.style.setProperty('transition', 'none', 'important');
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    this.classList.add('animate', 'active');
    this.lockMobileLayout();

    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    if (containerToTrapFocusOn && typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.error('Hock cart drawer: missing section response', parsedState);
      return;
    }

    if (typeof parsedState.item_count === 'number') {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
    } else {
      this.classList.remove('is-empty');
    }

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const html = parsedState.sections[section.id];

      if (!sectionElement || !html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = section.selector ? parsed.querySelector(section.selector) : parsed.body;
      if (!source) {
        console.error('Hock cart drawer: section selector not found', section.id, section.selector);
        return;
      }

      sectionElement.innerHTML = source.innerHTML;
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.removeEventListener('click', this._overlayClickHandler);
      overlay.addEventListener('click', this._overlayClickHandler);
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
